import { render, staticRenderFns } from "./MailTemplateModal.vue?vue&type=template&id=46c913a1&scoped=true&"
import script from "./MailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./MailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateModal.vue?vue&type=style&index=0&id=46c913a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c913a1",
  null
  
)

export default component.exports